<div class="main-view space-y-2 md:space-y-4">
  <app-page-surface-header
    titleIcon="clients"
    [title]="tenantName"
    subtitle="What this client's PDs cost in AI, and which of them cost the most."
  />

  <div class="panel">
    <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
      <div class="flex gap-2">
        @for (preset of presets; track preset.key) {
        <button
          type="button"
          [class]="selectedPreset === preset.key ? btn.smallPrimary : btn.smallSecondary"
          (click)="onPresetChange(preset.key)"
        >
          {{ preset.label }}
        </button>
        }
      </div>
      <a routerLink="/llm-cost" [class]="btn.smallSecondary">Back to dashboard</a>
    </div>

    @if (error) {
    <div class="mb-4 rounded border border-danger/40 bg-danger-light p-3 text-danger">{{ error }}</div>
    } @if (loading) {
    <div class="py-10 text-center text-white-dark">Loading…</div>
    } @else if (totals) {
    <div class="grid grid-cols-2 gap-4 md:grid-cols-4">
      <div class="panel bg-primary-light">
        <div class="text-xs uppercase text-white-dark">Total AI Cost</div>
        <div class="mt-1 text-2xl font-semibold">{{ formatUsd(totals.total_cost_usd) }}</div>
      </div>
      <div class="panel">
        <div class="text-xs uppercase text-white-dark">PDs Processed</div>
        <div class="mt-1 text-2xl font-semibold">{{ totals.pds | number }}</div>
        <div class="mt-1 text-xs text-white-dark">{{ formatUsd(totals.avg_cost_per_pd_usd) }} avg / PD</div>
      </div>
      <div class="panel">
        <div class="text-xs uppercase text-white-dark">LLM Calls</div>
        <div class="mt-1 text-2xl font-semibold">{{ totals.calls | number }}</div>
      </div>
      <div class="panel">
        <div class="text-xs uppercase text-white-dark">Total Tokens</div>
        <div class="mt-1 text-2xl font-semibold">{{ compactTokens(totals.total_tokens) }}</div>
      </div>
    </div>
    }
  </div>

  <div class="panel">
    <div class="mb-3 flex items-center justify-between">
      <h5 class="text-lg font-semibold">PD cost history</h5>
      <button type="button" [class]="btn.smallSecondary" (click)="exportPds()" [disabled]="!pds.length">
        Export CSV
      </button>
    </div>
    <div class="table-responsive">
      <table class="table-hover">
        <thead>
          <tr><th>PD Link</th><th>Agent</th><th class="text-right">Calls</th><th class="text-right">Tokens</th><th class="text-right">Cost</th><th>Last call</th></tr>
        </thead>
        <tbody>
          @for (row of pds; track row.session_code) {
          <tr>
            <td>
              <a [routerLink]="['/llm-pd-cost']" [queryParams]="{ session_code: row.session_code }" class="text-primary hover:underline">
                {{ row.session_code }}
              </a>
            </td>
            <td>{{ row.agent_id ?? '—' }}</td>
            <td class="text-right">{{ row.calls | number }}</td>
            <td class="text-right">{{ row.total_tokens | number }}</td>
            <td class="text-right font-semibold">{{ formatUsd(row.total_cost_usd) }}</td>
            <td class="whitespace-nowrap text-xs text-white-dark">{{ row.last_at | date : 'dd MMM yy HH:mm' }}</td>
          </tr>
          } @empty {
          <tr><td colspan="6" class="py-8 text-center text-white-dark">No PDs for this client in this period.</td></tr>
          }
        </tbody>
      </table>
    </div>
    @if (meta.pages > 1) {
    <div class="mt-4 flex items-center justify-between">
      <button type="button" [class]="btn.smallSecondary" [disabled]="meta.page <= 1" (click)="load(meta.page - 1)">Previous</button>
      <span class="text-sm text-white-dark">Page {{ meta.page }} of {{ meta.pages }}</span>
      <button type="button" [class]="btn.smallSecondary" [disabled]="meta.page >= meta.pages" (click)="load(meta.page + 1)">Next</button>
    </div>
    }
  </div>
</div>
